import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from '../_services/http.service';
import { NGXLogger } from 'ngx-logger';
import { NgModel } from '@angular/forms';
import { ActivatedRoute} from '@angular/router';
import { Router } from '@angular/router';
import * as configList from '../../assets/config/config';
import { UserService } from '../_services/user.service';
import { PasswordDataService } from '../_services/password-data.service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { CONFIGUREPORTALREQUEST } from '../_models/ConfigurePortal/configureportalrequest';

@Component({
  selector: 'app-activate-user',
  templateUrl: './activate-user.component.html',
  styleUrls: ['./activate-user.component.scss']
})
export class ActivateUserComponent implements OnInit {

  @ViewChild('userId') userId: NgModel;
  @ViewChild('submitBtn') submitBtn: any; // needed for ADA
  @ViewChild('userField') userField: any;
  @ViewChild('msg') msg: any;
  @ViewChild('msgText') msgText: any;
  public configurePortalRequest: CONFIGUREPORTALREQUEST;
  public errorMsg: string;
  public showAlertQS = false;
  public disableSave = false;
  passwordForm: FormGroup;
  public tooltipconstdata = configList.tooltipConst;
  public activateCode = '';

  constructor(private httpService: HttpService, private formBuilder: FormBuilder, private userDet: UserService,
    private route: ActivatedRoute, private logger: NGXLogger, private router: Router, private passwordData: PasswordDataService) {
      // this.activateCode = this.route.snapshot.queryParamMap.get('activateCode');
      this.activateCode = this.route.snapshot.params.token;
      sessionStorage.setItem('loginRoleId', '-1');
      sessionStorage.setItem('privilegeData', null);
      sessionStorage.setItem('userRoleId', '-1');
      sessionStorage.setItem('loginScreenId', '1');
      sessionStorage.setItem('logOut', 'Y');
      sessionStorage.setItem('isLoggedIn', 'false');
      sessionStorage.setItem('loggedInUserName', null);
      let tempAgreeClicked = localStorage.getItem('isAgreeClicked');
      let tempScreenInfo = localStorage.getItem('screenInfoData');
      localStorage.clear();
      if(tempScreenInfo != null){
        localStorage.setItem('screenInfoData',tempScreenInfo);
      }
      if(tempAgreeClicked != null){
        localStorage.setItem('isAgreeClicked',tempAgreeClicked);
      }
      if (this.activateCode === null && this.activateCode === undefined && this.activateCode === '') {
        this.userDet.authorizeUser();
      }
      this.passwordData.getDataFromJson();
    }

  ngOnInit() {
    if (!sessionStorage.getItem('screenInfoData')) {
      this.httpService.get_Screen(this.userDet.getScreenId(), this.userDet.getRoleId())
      .subscribe(
        (data: any) => {
          sessionStorage.setItem('screenInfoData', JSON.stringify(data));
          localStorage.setItem('screenInfoData', JSON.stringify(data));
        },
        (error) => {
          this.logger.debug('error in get screen service call');
        });
    } else {

    }
    if (this.msgText !== undefined) {
      this.msgText.nativeElement.removeAttribute('tabindex');
    }
    this.passwordForm = this.formBuilder.group({
      userId: ['', [Validators.required, this.checkSpaces]]
    });
    this.onChanges();
  }

  get f() { return this.passwordForm.controls; }

  /* This method is used to check if a field contains only spaces */
  checkSpaces(control: FormControl) {
    let condition = false;
    if (control.value !== null && (control.value).toString().trim() === '' && (control.value).toString().length > 0) {
      condition = true;
    }
    return condition ? { spaceError: true } : null;
  }

  /* This method is used to carry out some functionalities when the values of certain fields change */
  onChanges(): void {
    this.passwordForm.get('userId').valueChanges.subscribe(val => {
      this.passwordForm.get('userId').markAsTouched();
    });
  }

  /* This method returns the appropriate error message for new password field*/
  getUserError() {
    return this.passwordForm.get('userId').hasError('required') ? configList.errorConst.fieldError :
    this.passwordForm.get('userId').hasError('spaceError') ? configList.errorConst.onlySpaces : '';
  }

  /** This method relinquishes all the changes made to the form and redirects to the public-facing page */
  reRoutePublic(): void {
    this.passwordForm.reset();
    this.disableSave = false;
    sessionStorage.setItem('loginRoleId', '-1');
    sessionStorage.setItem('userRoleId', '-1');
    sessionStorage.setItem('privilegeData', null);
    sessionStorage.setItem('loginScreenId', '1');
    sessionStorage.setItem('logOut', 'Y');
    sessionStorage.setItem('isLoggedIn', 'false');
    sessionStorage.setItem('loggedInUserName', null);
    this.router.navigate(['/publicFacing']);
  }

  /** This method is called to Save the new password */
  submitUserId() {
    if (this.msgText !== undefined) {
      this.msgText.nativeElement.removeAttribute('tabindex');
    }
    this.configurePortalRequest = new CONFIGUREPORTALREQUEST();
    this.configurePortalRequest.screenId = configList.pageConst.pagePublicFacing;
    this.configurePortalRequest.updatedBy = this.f.userId.value;
    this.configurePortalRequest.portletId = configList.pageConst.NAPortletId;
    this.configurePortalRequest.activityCode = configList.activityCode.activateUser;
    const ruleEngineData = Object();
    ruleEngineData.userLoginId = this.f.userId.value;
    ruleEngineData.authToken = this.activateCode;
    // this.configurePortalRequest.encryptedContent = this.userDet.encryptData(ruleEngineData);
    this.configurePortalRequest.ruleEngineData = ruleEngineData;
    let finalData = Object();
    finalData.messageContent = this.userDet.encryptData(this.configurePortalRequest);

    // API call for saving reset password
    this.httpService.secureUserLoginTrack(finalData).subscribe(data => {
      data = this.userDet.decryptData(data.messageContent);
      sessionStorage.setItem('isLoggedIn', 'true');
      sessionStorage.setItem('loggedInUserName', data.ruleEngineResp.userLoginId);
      //sessionStorage.setItem('loginRoleId', data.ruleEngineResp.parentRoleId);
      sessionStorage.setItem('userRoleId', data.ruleEngineResp.roleId);
      sessionStorage.setItem('loginScreenId', data.ruleEngineResp.screenId);
      sessionStorage.setItem('loginUserStatus', data.ruleEngineResp.userStatus);
      sessionStorage.setItem('isTempPwd', data.ruleEngineResp.isTempPwd);
      sessionStorage.setItem('logOut', 'N');
      sessionStorage.setItem('LoginToken', data.loginToken);
      this.getProfileData(this.f.userId.value);

      // Storing session data in localstorage for Session Management's Multiple tab support
      localStorage.setItem('isLoggedIn', 'true');
      localStorage.setItem('loggedInUserName', data.ruleEngineResp.userLoginId);
      //localStorage.setItem('loginRoleId', data.ruleEngineResp.parentRoleId);
      localStorage.setItem('userRoleId', data.ruleEngineResp.roleId);
      localStorage.setItem('loginScreenId', data.ruleEngineResp.screenId);
      localStorage.setItem('loginUserStatus', data.ruleEngineResp.userStatus);
      sessionStorage.setItem('isTempPwd', data.ruleEngineResp.isTempPwd);
      localStorage.setItem('logOut', 'N');
      localStorage.setItem('isAgreeClicked', sessionStorage.getItem('isAgreeClicked'));
      if (data.ruleEngineResp.responseCode === 'RP001') {
        /* if (this.userField !== undefined) {
          this.userField.nativeElement.style.display = 'none';
        }
        if (this.submitBtn !== undefined) {
          this.submitBtn.nativeElement.style.display = 'none';
        }
        if (this.msg !== undefined) {
          this.msg.nativeElement.classList.remove('hidden');
          this.msg.nativeElement.classList.add('mt-5');
          if (this.msgText !== undefined) {
            this.msgText.nativeElement.style.color = 'blue';
            this.msgText.nativeElement.setAttribute('tabindex', '0');
            this.msgText.nativeElement.focus();
          }
        }
        this.errorMsg = configList.errorConst.generateEmail; */
        if (sessionStorage.getItem('loginUserStatus') === 'N') {
          // New user Reset Password Case
          if (data.ruleEngineResp.isTempPwd === 'Y') {
            this.router.navigate(['/resetPassword']);
          } else {
            this.router.navigate(['/resetSecurityQuestion']);
          }
        } else if (data.ruleEngineResp.isTempPwd === 'Y') {
          // Temp Password case
          this.router.navigate(['/validateSecurityQuestion']);
        }
      } else if (data.ruleEngineResp.responseCode === 'RP117' || data.ruleEngineResp.responseCode === 'RP111'
                || data.ruleEngineResp.responseCode === 'RP118') {
        this.errorMsg = data.ruleEngineResp.responseDesc;
        if (this.msg !== undefined) {
          this.msg.nativeElement.classList.remove('hidden');
          if (this.msgText !== undefined) {
            this.msgText.nativeElement.style.color = 'red';
            this.msgText.nativeElement.setAttribute('tabindex', '0');
            this.msgText.nativeElement.focus();
          }
        }
      } else {
        this.errorMsg = configList.errorConst.SystemError;
        if (this.msg !== undefined) {
          this.msg.nativeElement.classList.remove('hidden');
          if (this.msgText !== undefined) {
            this.msgText.nativeElement.style.color = 'red';
            this.msgText.nativeElement.setAttribute('tabindex', '0');
            this.msgText.nativeElement.focus();
          }
        }
      }
    },
    error => {
      this.logger.debug('Error while submitting Activate User');
    }
    );
  }

    /** This method is used to get profile data of the user */
    getProfileData(UserId) {
      let data = Object();
      data.userLoginId = UserId;
      let encryption = Object();
      encryption.messageContent =  this.userDet.encryptData(data);
      this.httpService.getUserProfileData(encryption).subscribe(
        (data: any) => {
          data = this.userDet.decryptData(data.messageContent);
          if(data) {
            sessionStorage.setItem('loggedInFirstName', data.firstName);
            // localStorage.setItem('loggedInFirstName', data.firstName);
          }
         
        });
    }

}
